module.exports = __webpack_public_path__ + "assets/action-required.62fecac6778a59fae46a6c834354938b.svg";